function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Find employe_icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M311.36,424.23a11.73,11.73,0,0,0-5.43-7.64,7.54,7.54,0,1,0-12.17,0,11.73,11.73,0,0,0-5.43,7.64A4,4,0,0,0,292.2,429h15.27A4,4,0,0,0,311.36,424.23ZM299.84,409.4a2.75,2.75,0,1,1-2.75,2.75A2.75,2.75,0,0,1,299.84,409.4Zm-6.56,14.86a6.86,6.86,0,0,1,6.5-4.55h0.13a6.86,6.86,0,0,1,6.5,4.55H293.28Z",
  transform: "translate(-270.86 -393.05)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M300.08,393a25.21,25.21,0,0,0-19.47,41.23l-9,8.75a2.45,2.45,0,1,0,3.41,3.51l9.05-8.8A25.21,25.21,0,1,0,300.08,393Zm0,45.54a20.32,20.32,0,1,1,20.32-20.32A20.35,20.35,0,0,1,300.08,438.59Z",
  transform: "translate(-270.86 -393.05)"
});

var SvgFindEmployeeIcon = function SvgFindEmployeeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 54.43 54.19",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFindEmployeeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FindEmployee_icon.8324bbd7.svg";
export { ForwardRef as ReactComponent };